import React, {createRef} from 'react';
import {ColorTheme} from 'src/styles/Colors';
import AppIcon from 'src/js/components/commons/AppIcon';
import AppImage from 'src/js/components/commons/AppImage';
import {RadiusView} from 'src/res/Radius';
import {FontWeightRegular} from 'src/res/FontWeight';
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import JackpotGameView, {SLOT_GAME_END_DELAY_MS,} from './JackpotGameView';
import AppText from "../commons/AppText";
import GameAudio from "../commons/GameAudio";
import {GAME_LOSE_AUDIO, GAME_PLAY_AUDIO, GAME_WIN_AUDIO} from "../../utils/GameAudioPlayer";
import {cloneDeep} from "lodash";
import {dispatchSimulationClick} from "src/js/utils/AppUtils";

export default class RouletteGameView extends React.Component {

    constructor(props) {
        super(props);
        this.selectionItems = props.items;
        this.refsOptions = {};

        const selectedIndexes = [];
        for (let i = 0; i < this.props.columns; i++) {
          selectedIndexes.push(props.preview ? i : 0);
          this.refsOptions[i] = createRef();
        }
        this.state = {
            ideal: true,
            reloadSelectedIndex: false,
            selectedIndexes: selectedIndexes
        };
    }

    componentWillUnmount() {
      this.refSlotView = null;
      for (let i = 0; i < this.props.columns; i++) {
        this.refsOptions[i].current = null;
      }
    }

  simulatePlay = () => {
      let delay = 0;
      if (this.refsOptions) {
        for (let i = 0; i < this.props.columns; i++) {
          const random = Math.random() * 100 % 4;
          if (random) {
            for (let j = 0; j < random; j++) {
              setTimeout(() => {
                const element = this.refsOptions[i].current;
                if (element) {
                  // element.click();
                  dispatchSimulationClick(element);
                }
              }, delay);
              delay += 500;
            }
          }
        }
      }
      setTimeout(() => {
        if (this.refSlotView) {
          this.refSlotView.simulatePlay();
        }
      }, delay + 800);
    }

    resetItems(items) {
        if (this.refSlotView) {
            this.refSlotView.resetItems(items);
        }
        this.selectionItems = items;
        const selectedIndexes = cloneDeep(this.state.selectedIndexes);
        this.setState({selectedIndexes: selectedIndexes});
    }

    stop(stopData) {
        this.isWin = stopData.isWin;
        if (this.refSlotView) {
            this.refSlotView.stop(stopData);
        }
    }

    reset() {
        const {selectedIndexes} = this.state;
        for (let i = 0; i < this.props.columns; i++) {
            selectedIndexes[i] = 0;
        }
        this.setState({ideal: true, selectedIndexes: selectedIndexes});

        if (this.refSlotView) {
            this.refSlotView.reset();
        }
    }

    playGamePlayAudio() {
        if (this.gamePlayAudioId) {
            this.gamePlayAudioId.play();
        }
    }

    playGameLoseAudio() {
        if (this.gamePlayAudioIdLose) {
            this.gamePlayAudioIdLose.play();
        }
    }

    playGameWinAudio() {
        if (this.gamePlayAudioIdWin) {
            this.gamePlayAudioIdWin.play();
        }
    }

    render() {
        const cardSize = this.getCardSize();
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const sizeVFactor = uiConfigs.sizeVFactor;
        return (
          <View style={{alignItems: 'center'}}>
            {!this.props.disableAudio ?
              <div>
                  <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gameLoseAudioUrl || GAME_PLAY_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gamePlayAudioIdLose = ref} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                  <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
              </div>
              : null
            }
              <View style={{position: 'relative', marginBottom: 22 * sizeVFactor}}>
                  <ImageBackground source={uiConfigs.cardsBgImage} resizeMode="fill" style={{position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, width: '100%', height: '100%'}}>
                  <View style={{position: 'relative', padding: 16 * sizeFactor, paddingBottom: 16 * sizeFactor, paddingTop: 34 * sizeFactor}}>
                      <View style={{position: 'absolute', left: 0, top: 0, right: 0, height: 28 * sizeFactor, alignItems: 'center', justifyContent: 'center'}}>
                          <AppText fontSizeN={uiConfigs.fontSize} style={{textTransform: 'uppercase', fontWeight: FontWeightRegular, color: uiConfigs.businessSubTitleColor}}>{locString('selectCombo')}</AppText>
                      </View>
                      <View style={{position: 'relative', flexDirection: 'row', height: cardSize + 2, width: cardSize * this.props.columns + 2, alignItems: 'center', justifyContent: 'center', overflow: 'hidden'}}>
                          <GetSelectedIndexesView
                            refs={this.refsOptions}
                            uiConfigs={uiConfigs}
                            cardSize={cardSize}
                            columns={this.props.columns}
                            selectedIndexes={this.state.selectedIndexes}
                            selectionItems={this.selectionItems}
                            ideal={this.state.ideal}
                            onClick={this.onClick}
                          />
                      </View>
                  </View>
                  </ImageBackground>
              </View>
              <JackpotGameView
                ref={this.handleJackpotRef}
                disableAudio={this.props.disableAudio}
                noActionMode={this.props.noActionMode || this.readOnly}
                onActionClickedInNoActionMode={this.props.onActionClickedInNoActionMode}
                mute={this.props.mute}
                preview={this.props.preview}
                classes={this.props.classes}
                contentWidth={this.props.contentWidth}
                contentHeight={this.props.contentHeight}
                uiConfigs={this.props.uiConfigs}
                isLTR={this.props.isLTR}
                items={this.props.items}
                columns={this.props.columns}
                rows={2}
                gameWinAudioUrl={this.props.gameWinAudioLocalUrl}
                gameLoseAudioUrl={this.props.gameLoseAudioLocalUrl}
                maxCardSize={cardSize}
                spinsLeft={this.props.spinsLeft}
                spinsCount={this.props.spinsCount}
                canSpin={this.props.canSpin}
                onImageClicked={this.props.onImageClicked}
                onSpinStarted={this.onSpinStarted}
                onSpinStopped={this.onSpinStopped}
              />
          </View>
        );
    }

    handleJackpotRef = (ref) => {
      this.refSlotView = ref;
    }

    onClick = (column) => {
        if (this.props.noActionMode) {
            this.props.onActionClickedInNoActionMode();
            return;
        }

        this.playGamePlayAudio();
        const selectedIndexes = cloneDeep(this.state.selectedIndexes);
        const index = selectedIndexes[column];
        let newIndex = index + 1;
        if (newIndex === this.selectionItems.length) {
            newIndex = 0;
        }
        selectedIndexes[column] = newIndex;
        this.setState({selectedIndexes: selectedIndexes})
    };

    onSpinStarted = () => {
      this.setState({ideal: false});
      if (this.props.onSpinStarted) {
        let selectedSlots = [];
        this.state.selectedIndexes.forEach((index) => {
          selectedSlots.push(this.selectionItems[index].id);
        });
        this.props.onSpinStarted(selectedSlots);
      }
    }

    onSpinStopped = () => {
        if (this.isWin) {
            this.isWin = false;
            this.playGameWinAudio();
        } else {
            this.playGameLoseAudio();
        }
        // Vibration.vibrate(200);

        setTimeout(() => {
            this.setState({ideal: true});
            if (this.props.onSpinStopped) {
                this.props.onSpinStopped();
            }
        }, SLOT_GAME_END_DELAY_MS);
    }

    getCardSize() {
        const sizeFactor = this.props.uiConfigs.sizeFactor;
        const rows = 2.5;
        const columns = this.props.columns;

        const otherUiHeight = 200 * sizeFactor;
        const borderWidth = 60 * sizeFactor;
        const possibleWidth = (this.props.contentWidth - borderWidth) / columns; // borderWidth
        const possibleHeight = (this.props.contentHeight - otherUiHeight - borderWidth) / rows; // borderWidth
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        return Math.floor(Math.min(200, possibleSize));
    }
}

const GetSelectedIndexesView = React.memo((props) => {
    const {uiConfigs, cardSize, columns, selectionItems,
        ideal, selectedIndexes, refs,
        onClick} = props;
    const views = [];
    for (let i = 0; i < columns; i++) {
        const index = selectedIndexes[i];
        const item = selectionItems[index];
        const boxSize = cardSize;
        const cardBgImage = uiConfigs.cardBgImage;
        const padding = 4;
        views.push(
          <View key={item.key} style={{width: boxSize, height: boxSize, padding: padding}}>
              {cardBgImage ? <ImageBackground source={uiConfigs.cardBgImage} resizeMode="fill" style={{position: 'absolute', left: 1, top: 0, right: 1, bottom: 0, borderRadius: 0}} /> : null}
              <TouchableOpacity ref={refs[i]} disabled={!ideal} key={'S'+ item.id} style={{opacity: ideal ? 1 : 0.8}} onClick={() => {
                  onClick(i);
              }}>
                  <View style={{alignItems: 'center', justifyContent: 'center', borderRadius: RadiusView}}>
                      {item.imageUrl ?
                        <AppImage
                          style={{
                              height: boxSize - (2 * padding),
                              width: boxSize - (2 * padding),
                              borderRadius: RadiusView
                          }}
                          imageUrl={item.imageUrl}
                          resizeMode={'contain'}
                        />
                        : item.icon ? <AppIcon icon={item.icon} color={item.color ? item.color : ColorTheme} size={36} /> : null}
                  </View>
              </TouchableOpacity>
          </View>
        );
    }
    return views;
});
